<!-- <app-module-list
  [moduleId]="10009"
  [customUrlPrefix]="'/apps/timesheet/project/'"
></app-module-list> -->

<ng-template #drawerTemplate let-drawerRef="drawerRef">
  <nz-row>
    <div nz-col nzXs="24" nzMd="18" class="tempCol">
      <input
        type="text"
        [(ngModel)]="tempNote"
        nz-input
        [placeholder]="'Please write your note here' | locale"
      />
    </div>
    <div nz-col nzXs="24" nzMd="6" class="tempCol">
      <nz-select [(ngModel)]="isApproved" style="width: 100%">
        <nz-option [nzValue]="true" [nzLabel]="'Approve' | locale"></nz-option>
        <nz-option [nzValue]="false" [nzLabel]="'Reject' | locale"></nz-option>
      </nz-select>
    </div>
  </nz-row>
</ng-template>
<ng-template #footerTemp>
  <nz-space>
    <nz-space-item
      ><button nz-button nzType="primary" locale (click)="submit()">
        Submit
      </button></nz-space-item
    >
    <nz-space-item
      ><button nz-button nzType="default" locale>Close</button></nz-space-item
    >
  </nz-space>
</ng-template>
